<template>
  <div
    class="dashboard"
    :class="{
      collapsed: this.$root.isCollapsed && !isMobile,
      notification:
        this.$root.warning && this.$root.warning !== 'NORMAL' && !isMobile,
    }"
  >
    <div class="wrapper-1" style="padding-top: 95px">
      <div class="frame-35732">
        <div class="frame-35733">
          <div
            class="small-chart"
            @click="
              dashboardData?.order_received_count !== 0 &&
                redirect('active-orders')
            "
          >
            <div class="frame-35703">
              <div class="cash">{{ dashboardData?.order_received_count }}</div>
              <div class="label">{{ $t("orders-received") }}</div>
            </div>
            <div class="frame-35701">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <path
                  d="M18.466 38.4001C18.466 38.9538 18.3018 39.4952 17.9941 39.9557C17.6865 40.4161 17.2492 40.775 16.7375 40.9869C16.2259 41.1988 15.6629 41.2543 15.1198 41.1463C14.5766 41.0382 14.0777 40.7715 13.6861 40.38C13.2945 39.9884 13.0279 39.4895 12.9198 38.9463C12.8118 38.4032 12.8672 37.8402 13.0792 37.3285C13.2911 36.8169 13.65 36.3796 14.1104 36.0719C14.5709 35.7643 15.1122 35.6001 15.666 35.6001C16.4086 35.6001 17.1208 35.8951 17.6459 36.4202C18.171 36.9453 18.466 37.6574 18.466 38.4001ZM33.866 35.6001C33.3122 35.6001 32.7709 35.7643 32.3104 36.0719C31.85 36.3796 31.4911 36.8169 31.2792 37.3285C31.0672 37.8402 31.0118 38.4032 31.1198 38.9463C31.2279 39.4895 31.4945 39.9884 31.8861 40.38C32.2777 40.7715 32.7766 41.0382 33.3198 41.1463C33.8629 41.2543 34.4259 41.1988 34.9375 40.9869C35.4492 40.775 35.8865 40.4161 36.1941 39.9557C36.5018 39.4952 36.666 38.9538 36.666 38.4001C36.666 37.6574 36.371 36.9453 35.8459 36.4202C35.3208 35.8951 34.6086 35.6001 33.866 35.6001ZM42.2153 13.5745L37.7283 29.7236C37.4816 30.6057 36.9539 31.3834 36.2253 31.9386C35.4968 32.4937 34.607 32.7962 33.691 32.8001H16.394C15.4753 32.7996 14.582 32.4988 13.8502 31.9433C13.1185 31.3878 12.5884 30.6083 12.341 29.7236L6.20202 7.60005H3.06602C2.69471 7.60005 2.33862 7.45255 2.07607 7.19C1.81352 6.92745 1.66602 6.57135 1.66602 6.20005C1.66602 5.82875 1.81352 5.47265 2.07607 5.2101C2.33862 4.94755 2.69471 4.80005 3.06602 4.80005H7.26602C7.57209 4.79999 7.86976 4.90024 8.11344 5.08545C8.35712 5.27066 8.53339 5.53063 8.61527 5.82555L10.2743 11.8H40.866C41.0818 11.8 41.2948 11.8499 41.4881 11.9457C41.6815 12.0416 41.8501 12.1809 41.9807 12.3527C42.1114 12.5245 42.2005 12.7242 42.2412 12.9361C42.2819 13.1481 42.273 13.3666 42.2153 13.5745ZM39.0233 14.6H11.053L15.0448 28.9746C15.1266 29.2695 15.3029 29.5294 15.5466 29.7146C15.7903 29.8999 16.0879 30.0001 16.394 30H33.691C33.9971 30.0001 34.2948 29.8999 34.5384 29.7146C34.7821 29.5294 34.9584 29.2695 35.0403 28.9746L39.0233 14.6Z"
                  fill="#224096"
                />
                <path
                  d="M33.0361 16.1049C33.1663 16.235 33.2696 16.3894 33.34 16.5593C33.4105 16.7293 33.4467 16.9115 33.4467 17.0954C33.4467 17.2794 33.4105 17.4616 33.34 17.6316C33.2696 17.8015 33.1663 17.9559 33.0361 18.0859L24.1714 26.9526C24.0413 27.0828 23.8869 27.186 23.717 27.2565C23.547 27.3269 23.3648 27.3632 23.1809 27.3632C22.9969 27.3632 22.8147 27.3269 22.6447 27.2565C22.4748 27.186 22.3204 27.0828 22.1904 26.9526L17.9904 22.7526C17.7277 22.4899 17.5801 22.1336 17.5801 21.7621C17.5801 21.3906 17.7277 21.0343 17.9904 20.7716C18.2531 20.5089 18.6093 20.3613 18.9809 20.3613C19.3524 20.3613 19.7087 20.5089 19.9714 20.7716L23.1809 23.9828L31.0551 16.1049C31.1852 15.9748 31.3396 15.8715 31.5095 15.8011C31.6795 15.7306 31.8617 15.6943 32.0456 15.6943C32.2296 15.6943 32.4118 15.7306 32.5818 15.8011C32.7517 15.8715 32.9061 15.9748 33.0361 16.1049Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-lg"
            v-if="!mobile"
            style="color: #224096"
          ></i>
          <div
            class="small-chart"
            @click="
              dashboardData?.order_in_progress_count !== 0 &&
                redirect('active-orders')
            "
          >
            <div class="frame-35703">
              <div class="cash">
                {{ dashboardData?.order_in_progress_count }}
              </div>
              <div class="label">{{ $t("in-progress") }}</div>
            </div>
            <div class="frame-35701">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <path
                  d="M37.3327 7.6001H9.33271C8.59011 7.6001 7.87792 7.8951 7.35282 8.4202C6.82771 8.9453 6.53271 9.65749 6.53271 10.4001V20.2001C6.53271 29.4261 10.9987 35.0173 14.7455 38.0833C18.781 41.3838 22.7955 42.5038 22.9705 42.5511C23.2111 42.6166 23.4648 42.6166 23.7055 42.5511C23.8805 42.5038 27.8897 41.3838 31.9305 38.0833C35.6667 35.0173 40.1327 29.4261 40.1327 20.2001V10.4001C40.1327 9.65749 39.8377 8.9453 39.3126 8.4202C38.7875 7.8951 38.0753 7.6001 37.3327 7.6001ZM37.3327 20.2001C37.3327 26.6873 34.9422 31.9531 30.2277 35.8486C28.1755 37.5386 25.8414 38.8537 23.3327 39.7336C20.8568 38.869 18.5516 37.5772 16.5217 35.9168C11.7512 32.0143 9.33271 26.7276 9.33271 20.2001V10.4001H37.3327V20.2001ZM15.3422 25.3906C15.0795 25.1279 14.9319 24.7716 14.9319 24.4001C14.9319 24.0286 15.0795 23.6723 15.3422 23.4096C15.6049 23.1469 15.9612 22.9993 16.3327 22.9993C16.7042 22.9993 17.0605 23.1469 17.3232 23.4096L20.5327 26.6208L29.3422 17.8096C29.4723 17.6795 29.6267 17.5763 29.7967 17.5059C29.9666 17.4356 30.1488 17.3993 30.3327 17.3993C30.5167 17.3993 30.6988 17.4356 30.8688 17.5059C31.0387 17.5763 31.1931 17.6795 31.3232 17.8096C31.4533 17.9397 31.5565 18.0941 31.6269 18.264C31.6973 18.434 31.7335 18.6161 31.7335 18.8001C31.7335 18.9841 31.6973 19.1662 31.6269 19.3362C31.5565 19.5061 31.4533 19.6605 31.3232 19.7906L21.5232 29.5906C21.3932 29.7208 21.2388 29.824 21.0688 29.8945C20.8989 29.9649 20.7167 30.0012 20.5327 30.0012C20.3487 30.0012 20.1666 29.9649 19.9966 29.8945C19.8266 29.824 19.6722 29.7208 19.5422 29.5906L15.3422 25.3906Z"
                  fill="#224096"
                />
              </svg>
            </div>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-lg"
            v-if="!mobile"
            style="color: #224096"
          ></i>
          <div
            class="small-chart"
            @click="
              dashboardData?.order_delivered_count !== 0 &&
                redirect('delivered-reports')
            "
          >
            <div class="frame-35703">
              <div class="cash">{{ dashboardData?.order_delivered_count }}</div>
              <div class="label">{{ $t("order-delivered") }}</div>
            </div>
            <div class="frame-35701">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M39.7077 12.8C39.4464 12.3707 39.0917 12.016 38.6437 11.7733L23.2437 3.35467C22.833 3.13067 22.3664 3 21.8997 3C21.433 3 20.9664 3.13067 20.5557 3.35467L5.15571 11.7733C4.72637 12.016 4.35304 12.3707 4.09171 12.8C3.83037 13.248 3.69971 13.7333 3.69971 14.2373V30.9627C3.69971 31.4667 3.83037 31.9707 4.09171 32.4C4.35304 32.8293 4.72637 33.184 5.15571 33.4267L20.5557 41.8453C20.9664 42.0693 21.433 42.2 21.8997 42.2C22.3664 42.2 22.833 42.0693 23.2437 41.8453L27.985 39.2507L25.9317 37.1973L23.2997 38.6347V23.6267L37.2997 15.9547V26.4267C37.505 26.2773 37.729 26.1467 37.9717 26.0533C38.4197 25.8667 38.905 25.7733 39.3904 25.7733C39.633 25.7733 39.857 25.792 40.0997 25.848V14.2373C40.0997 13.7333 39.969 13.2293 39.7077 12.8ZM20.4997 38.6347L6.49971 30.9627V15.9547L20.4997 23.608V38.6347ZM21.8997 21.2L7.84371 13.5093L13.7797 10.2613L27.8357 17.952L21.8997 21.2ZM30.7477 16.3467L16.6917 8.656L21.8997 5.8L35.9557 13.5093L30.7477 16.3467Z"
                  fill="#224096"
                />
                <path
                  d="M41.4997 29.04C41.4997 29.2267 41.4624 29.4133 41.3877 29.5813C41.3317 29.7493 41.2197 29.8987 41.089 30.0293L40.0997 31.0187L36.553 34.584L32.2224 38.896C32.0917 39.0267 31.9424 39.1387 31.7744 39.1947C31.6064 39.2693 31.4197 39.3067 31.233 39.3067C31.0464 39.3067 30.8597 39.2693 30.6917 39.1947C30.5237 39.1387 30.3744 39.0267 30.2437 38.896L26.0437 34.696C25.7824 34.4347 25.633 34.08 25.633 33.7067C25.633 33.3333 25.7824 32.9787 26.0437 32.7173C26.305 32.456 26.6597 32.3067 27.033 32.3067C27.4064 32.3067 27.761 32.456 28.0224 32.7173L31.233 35.928L39.1104 28.0507C39.241 27.92 39.3904 27.8267 39.5584 27.752C39.7264 27.6773 39.913 27.64 40.0997 27.64C40.2864 27.64 40.473 27.6773 40.641 27.752C40.809 27.8267 40.9584 27.92 41.089 28.0507C41.2197 28.1813 41.3317 28.3307 41.3877 28.4987C41.4624 28.6853 41.4997 28.8533 41.4997 29.04Z"
                  fill="#224096"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div
        class="frame-35731"
        style="
          padding: 20px;
          flex-direction: column;
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 10px 10px 30px 0px rgba(174, 174, 192, 0.4),
            -10px -10px 30px 0px rgba(255, 255, 255, 1);
        "
      >
        <div
          class="total-orders-wrapper"
          :style="{
            justifyContent:
              showAnalytics === 'USER_COUNT' ? 'flex-end' : 'space-between',
            minHeight: '100px',
          }"
        >
          <!--Order Cards Section-->
          <div
            class="avg-count-wrapper"
            :style="{
              visibility: showAnalytics === 'USER_COUNT' ? 'hidden' : '',
              height: 'auto',
            }"
          >
            <div class="total-orders">
              <div class="total-orders-title">{{ $t("total-order") }}</div>

              <div class="total-orders-value">{{ totalOrdersCovered }}</div>
            </div>
            <div class="total-orders">
              <div class="total-orders-title">
                {{ $t("avg-reports") }}
                {{
                  showAnalytics === "MONTHLY"
                    ? $t("month")
                    : showAnalytics === "WEEKLY"
                    ? $t("week")
                    : $t("user")
                }}
              </div>
              <div class="total-orders-value">
                {{ Math.round(averageOrderCount) }}
              </div>
            </div>
          </div>
          <!-- Filter Section -->
          <div class="buttons-wrapper">
            <div
              class="total-orders-title"
              style="margin-top: 7px"
              v-if="showAnalytics === 'USER_COUNT'"
            >
              {{ $t("filter-date") }}
            </div>
            <!-- Start Date Input -->
            <input
              type="date"
              :value="startDate"
              @change="handleStartDateChange"
              :min="today"
              :max="endDate"
              :disabled="!startDate"
              :style="{
                color: '#224096',
                backgroundColor: '#F4F7FE',
                border: '1px white',
              }"
              class="buttons"
              @click="openDatePicker($event)"
              @focus="focusedInput = 'startDate'"
              @blur="focusedInput = null"
              v-if="showAnalytics === 'USER_COUNT'"
              @keydown.prevent
            />
            <!-- Partition -->
            <span style="margin-top: 8px" v-if="showAnalytics === 'USER_COUNT'">
              -
            </span>
            <!-- End Date Input -->
            <input
              type="date"
              :value="endDate"
              @change="handleEndDateChange"
              :min="startDate"
              :max="formatDate(today)"
              :disabled="!startDate"
              :style="{
                color: '#224096',
                backgroundColor: '#F4F7FE',
                border: '1px white',
              }"
              class="buttons"
              @click="openDatePicker($event)"
              @focus="focusedInput = 'endDate'"
              @blur="focusedInput = null"
              v-if="showAnalytics === 'USER_COUNT'"
              @keydown.prevent
            />
            <!-- Graph Tabs -->

            <div
              class="buttons"
              :style="{
                color: showAnalytics === 'USER_COUNT' ? 'white' : '#224096',
                backgroundColor:
                  showAnalytics === 'USER_COUNT' ? '#224096' : '#F4F7FE',
              }"
              @click="setTabValue('USER_COUNT')"
            >
              {{ $t("user-view") }}
            </div>
            <div
              class="buttons"
              :style="{
                color: showAnalytics === 'MONTHLY' ? 'white' : '#224096',
                backgroundColor:
                  showAnalytics === 'MONTHLY' ? '#224096' : '#F4F7FE',
              }"
              @click="setTabValue('MONTHLY')"
            >
              {{ $t("monthly") }}
            </div>
            <div
              class="buttons"
              :style="{
                color: showAnalytics === 'WEEKLY' ? 'white' : '#224096',
                backgroundColor:
                  showAnalytics === 'WEEKLY' ? '#224096' : '#F4F7FE',
              }"
              @click="setTabValue('WEEKLY')"
            >
              {{ $t("weekly") }}
            </div>
          </div>
        </div>

        <div class="large-chart-per-month">
          <ag-charts-vue :options="options"> </ag-charts-vue>
        </div>
        <!-- <div class="frame-35734">
          <div class="accounts-payable-wrapper">
            <div class="accounts-payable">
              <div class="accounts-payable-value-wrapper">
                <div class="accounts-payable-value">2,475 USD</div>
                <i
                  class="fa-solid fa-angle-down fa-lg"
                  style="color: white"
                ></i>
              </div>
              <div class="accounts-payable-title">Accounts payable</div>
            </div>
            <div class="days-due-wrapper">
              <div class="days-button">
                <div
                  class="days"
                  :style="{
                    color: numberOfDays === '60' ? '#224096' : 'white',
                    background: numberOfDays === '60' ? 'white' : '#224096',
                  }"
                  @click="toggleNumberOfDays('60')"
                >
                  60
                </div>
                <div
                  class="days"
                  :style="{
                    color: numberOfDays === '30' ? '#224096' : 'white',
                    background: numberOfDays === '30' ? 'white' : '#224096',
                  }"
                  @click="toggleNumberOfDays('30')"
                >
                  30
                </div>
              </div>
              <div class="accounts-payable-title" style="text-align: right">
                Days due
              </div>
            </div>
          </div>
          <div class="report-details-wrapper">
            <div
              class="report-details"
              v-for="report in deliveredReports.slice(0, 5)"
              :key="report.id"
            >
              <div class="company-name">{{ report.name }}</div>
              <div class="price">{{ report.amount }} USD</div>
            </div>
          </div>
          <div class="view-all">
            <span>View All</span>
            <svg
              class="keyboard-backspace"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 13L17.67 13L14.09 16.59L15.5 18L21.5 12L15.5 6L14.09 7.41L17.67 11L3.5 11L3.5 13Z"
                fill="white"
              />
            </svg>
          </div>
        </div> -->
      </div>
      <div class="frame-35731">
        <div class="avg-data">
          <div class="avg-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="46"
              viewBox="0 0 45 46"
              fill="none"
            >
              <g clip-path="url(#clip0_1409_1611)">
                <path
                  d="M33.7474 12.2623C33.6724 12.0823 33.5674 11.9174 33.4324 11.7824L22.935 1.28499C22.7851 1.15002 22.6201 1.03005 22.4401 0.955072C22.2602 0.88009 22.0652 0.850098 21.8703 0.850098H3.87475C3.07994 0.850098 2.31513 1.16502 1.74527 1.71988C1.19041 2.28974 0.875488 3.05455 0.875488 3.84935V36.8412C0.875488 37.636 1.19041 38.4008 1.74527 38.9557C2.30013 39.5105 3.07994 39.8404 3.87475 39.8404H23.6249C23.3699 38.8807 23.2349 37.8759 23.22 36.8412H3.87475V3.84935H20.3707V12.8471C20.3707 13.237 20.5206 13.6269 20.8055 13.8969C21.0905 14.1818 21.4654 14.3468 21.8703 14.3468H30.8681V24.8741C31.8128 24.4543 32.8176 24.1543 33.8673 23.9744V12.8471C33.8673 12.6522 33.8223 12.4572 33.7474 12.2623ZM23.3699 11.3475V5.96383L28.7386 11.3475H23.3699Z"
                  fill="#224096"
                />
                <path
                  d="M41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363Z"
                  fill="white"
                />
                <path
                  d="M41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363ZM41.4104 36.1363C41.2904 36.0014 41.1104 35.9264 40.9305 35.9264H36.7615V31.7574C36.7615 31.5775 36.6865 31.3975 36.5516 31.2776C36.4316 31.1426 36.2516 31.0676 36.0567 31.0676C35.8767 31.0676 35.6968 31.1426 35.5768 31.2776C35.4418 31.3975 35.3669 31.5775 35.3669 31.7574V36.6312C35.3669 36.8112 35.4418 36.9911 35.5768 37.1111C35.6968 37.2461 35.8767 37.3211 36.0567 37.3211H40.9305C41.1104 37.3211 41.2904 37.2461 41.4104 37.1111C41.5453 36.9911 41.6203 36.8112 41.6203 36.6312C41.6203 36.4363 41.5453 36.2563 41.4104 36.1363Z"
                  fill="#224096"
                />
                <path
                  d="M42.4452 30.2428C40.7506 28.5482 38.4562 27.6035 36.0568 27.5885C35.307 27.5885 34.5721 27.6784 33.8673 27.8734C32.8625 28.1133 31.9178 28.5332 31.048 29.1181C30.988 29.1631 30.928 29.2081 30.868 29.253C29.4734 30.2278 28.3787 31.5925 27.7188 33.1671C27.2389 34.3368 27.014 35.5815 27.059 36.8412C27.059 37.351 27.104 37.8759 27.209 38.3858C27.3139 38.8807 27.4489 39.3755 27.6288 39.8404C28.0787 41.0251 28.7686 42.1049 29.6833 43.0046C30.943 44.2793 32.5476 45.1341 34.3022 45.479C36.0568 45.8239 37.8713 45.644 39.5209 44.9692C41.1705 44.2793 42.5801 43.1246 43.5699 41.64C44.5597 40.1553 45.0995 38.4158 45.0995 36.6312C45.0845 34.2318 44.1398 31.9374 42.4452 30.2428ZM41.4704 42.0299C40.0308 43.4545 38.0963 44.2643 36.0568 44.2643C34.5571 44.2643 33.0725 43.8144 31.8128 42.9746C30.6581 42.1948 29.7133 41.1151 29.1435 39.8404C29.0835 39.7504 29.0535 39.6455 29.0085 39.5555C28.6486 38.6857 28.4536 37.7559 28.4387 36.8412C28.4087 36.2713 28.4536 35.7014 28.5736 35.1316C28.8585 33.647 29.5934 32.2973 30.6581 31.2176C30.7181 31.1576 30.7931 31.0826 30.868 31.0226C31.7228 30.2278 32.7426 29.6279 33.8673 29.313C34.1072 29.238 34.3322 29.1781 34.5721 29.1331C36.0568 28.8331 37.5864 28.9831 38.981 29.568C40.3907 30.1378 41.5754 31.1276 42.4152 32.3723C43.255 33.632 43.7049 35.1166 43.7049 36.6312C43.7049 38.6557 42.8951 40.5902 41.4704 42.0299Z"
                  fill="#224096"
                />
              </g>
              <defs>
                <clipPath id="clip0_1409_1611">
                  <rect
                    width="44.8"
                    height="44.8"
                    fill="white"
                    transform="translate(0.0996094 0.850098)"
                  />
                </clipPath>
              </defs>
            </svg>
            <div class="avg-value">{{ dashboardData?.avg_time }}</div>
            <div class="avg-lable">{{ $t("fresh-report-heading") }}</div>
          </div>
          <div class="avg-card">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="45"
              height="46"
              viewBox="0 0 45 46"
              fill="none"
            >
              <path
                d="M36.4259 11.5221C32.7982 9.70912 27.9822 8.75012 22.4994 8.75012C17.0167 8.75012 12.2007 9.70912 8.57291 11.5221C4.94516 13.3351 2.89941 15.8866 2.89941 18.5501V26.9501C2.89941 29.6136 4.96791 32.1739 8.57291 33.9781C12.1779 35.7824 17.0167 36.7501 22.4994 36.7501C27.9822 36.7501 32.7982 35.7911 36.4259 33.9781C40.0537 32.1651 42.0994 29.6136 42.0994 26.9501V18.5501C42.0994 15.8866 40.0309 13.3264 36.4259 11.5221ZM22.4994 11.5501C33.4614 11.5501 39.2994 15.6154 39.2994 18.5501C39.2994 21.4849 33.4614 25.5501 22.4994 25.5501C11.5374 25.5501 5.69941 21.4849 5.69941 18.5501C5.69941 15.6154 11.5374 11.5501 22.4994 11.5501ZM21.0994 28.3256V33.9256C17.7744 33.8171 14.9744 33.3271 12.6994 32.6149V27.1339C15.4419 27.8645 18.2619 28.2646 21.0994 28.3256ZM23.8994 28.3256C26.7369 28.2646 29.5569 27.8645 32.2994 27.1339V32.6131C30.0244 33.3254 27.2244 33.8154 23.8994 33.9239V28.3256ZM5.69941 26.9501V23.7179C6.58046 24.4492 7.54501 25.0736 8.57291 25.5781C8.99816 25.7899 9.44791 25.9894 9.89941 26.1784V31.5001C7.12916 30.1281 5.69941 28.4009 5.69941 26.9501ZM35.0994 31.5001V26.1784C35.5562 25.9894 36.0007 25.7899 36.4259 25.5781C37.4538 25.0736 38.4184 24.4492 39.2994 23.7179V26.9501C39.2994 28.4009 37.8697 30.1281 35.0994 31.5001Z"
                fill="#224096"
              />
            </svg>
            <div class="avg-value">{{ dashboardData?.avg_price }} USD</div>
            <div class="avg-lable">
              {{ $t("avg-cost") }}
              {{ EntityType === "CORPORATE" ? "Fresh" : none }}
              {{ $t("report") }}
            </div>
          </div>
        </div>
        <div class="map">
          <Map
            property1="mouse-enter"
            version="3"
            style="flex-shrink: 0; width: 100%"
          ></Map>
        </div>
      </div>
    </div>
  </div>
  <Toastify ref="toastContainer" />
</template>
<script>
import Toastify from "@/components/Toastify.vue";
import { AgChartsVue } from "ag-charts-vue3";
import VueCookies from "vue-cookies";
import { GetDashboardData, OrderCountAnalytics } from "@/api/APIs";
import Map from "@/components/DashboardMap/DashboardMap.vue";
import { format, subMonths } from "date-fns";

export default {
  name: "BankUserDashboard",
  components: {
    Toastify,
    AgChartsVue,
    Map,
  },
  props: {},
  data() {
    return {
      showScrollToTop: false,
      focusedInput: null,
      numberOfDays: "60",
      dashboardData: null,
      orderAnalyticsData: null,
      showAnalytics: "USER_COUNT",
      mobile: window.innerWidth <= 767,
      EntityType: VueCookies.get("EntityType"),
      isMobile: window.innerWidth < 1023,
      options: {
        data: [],
        series: [],
      },
      today: new Date(),
      startDate: null,
      endDate: null,
    };
  },
  watch: {
    showAnalytics(newVal) {
      this.OrderCount(newVal);
    },
  },
  computed: {
    averageOrderCount() {
      return this.totalOrdersCovered / 12;
    },
    totalOrdersCovered() {
      if (this.orderAnalyticsData && Array.isArray(this.orderAnalyticsData)) {
        return this.orderAnalyticsData.reduce(
          (acc, item) => acc + (item.orderCount || 0),
          0
        );
      }
      return 0;
    },
    formattedStartDate() {
      return this.startDate ? this.formatDate(this.startDate) : null;
    },
    formattedEndDate() {
      return this.endDate ? this.formatDate(this.endDate) : null;
    },
  },

  async mounted() {
    this.setDefaultDates();
    await this.DashboardData();
    await this.OrderCount(this.showAnalytics);
  },
  beforeUnmount() {},
  methods: {
    redirect(tab) {
      this.$router.push({ path: "/MyOrders", query: { tab: tab } });
    },
    setTabValue(value) {
      this.showAnalytics = value;
      this.setDefaultDates();
    },
    openDatePicker(event) {
      // Force the input to focus to open the date picker
      event.target.showPicker?.();
    },
    toggleNumberOfDays(value) {
      if (this.numberOfDays !== value) {
        this.numberOfDays = value;
      }
    },
    async DashboardData() {
      try {
        const response = await GetDashboardData();
        if (response) {
          this.dashboardData = response;
        } else {
          return this.$refs.toastContainer.addToast(response.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error.response && error.response.status !== 403) {
          return this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    async OrderCount(value) {
      const payload = {
        filter: value,
      };
      const payload1 = {
        filter: value,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      try {
        const response = await OrderCountAnalytics(
          value == "USER_COUNT" ? payload1 : payload
        );
        if (response) {
          if (value == "USER_COUNT") {
            this.orderAnalyticsData = response;
            this.options.data = response;
          } else {
            this.orderAnalyticsData = response?.slice(0, 12);
            this.options.data = response?.slice(0, 12);
          }

          // Graph Section
          const userNames = new Set();
          response?.forEach((periodData) => {
            Object.keys(periodData)?.forEach((key) => {
              if (key !== "period" && key !== "week_start") {
                userNames.add(key);
              }
            });
          });

          const series = [];
          userNames?.forEach((user) => {
            const userSeries = {
              type: "bar",
              cursor: "pointer",
              xKey: "period",
              yKey: user,
              bar: {
                widthRatio: 0.2,
              },
              yName: user,
              cornerRadius: 8,
              fill: "#224096",
              strokeWidth: 0,
              shadow: {
                enabled: true,
              },
            };
            series.push(userSeries);
          });
          // set option's series
          this.options.series = series;

          // this.options.data = response?.map(orderData => {
          //   const formattedData = { period: orderData?.period };
          //   userNames?.forEach(user => {
          //     formattedData[user] = orderData[user] || 0;
          //   });
          //   return formattedData;
          // });
        } else {
          this.$refs.toastContainer.addToast(response?.message, {
            type: "error",
          });
        }
      } catch (error) {
        if (error?.response && error?.response?.status !== 403) {
          this.$refs.toastContainer.addToast(
            "Something went wrong. Please try again later.",
            { type: "error" }
          );
        }
      }
    },
    setDefaultDates() {
      const oneMonthAgo = subMonths(this.today, 1);
      this.startDate = this.formatDate(oneMonthAgo);
      this.endDate = this.formatDate(this.today);
    },
    formatDate(date) {
      return format(date, "yyyy-MM-dd");
    },
    handleStartDateChange(event) {
      this.startDate = event.target.value;
      if (this.startDate > this.endDate) {
        this.endDate = this.startDate;
      }
      this.OrderCount(this.showAnalytics);
    },
    handleEndDateChange(event) {
      this.endDate = event.target.value;
      this.OrderCount(this.showAnalytics);
    },
  },
};
</script>
<style>
.dashboard,
.dashboard * {
  box-sizing: border-box;
}

.dashboard {
  background: #eef7ff;
  display: flex;
  flex-direction: column;
  margin-left: 18vw;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  transition: margin-left 0.3s ease;
}

.dashboard.collapsed {
  margin-left: 60px;
}
.dashboard.notification {
  padding-top: 105px !important;
}
.navbar-instance {
  background: #ffffff !important;
  flex-shrink: 0 !important;
  width: 1440px !important;
}

.frame-35705 {
  background: #e2eaf5;
  padding: 20px 40px 20px 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  right: 0px;
  top: 0px;
  overflow: hidden;
}

.frame-357042 {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}

.welcome-to-credence {
  color: var(--secondary-grey-900, #2b3674);
  text-align: left;
  font-family: "Figtree";
  font-size: 24px;
  line-height: 42px;
  font-weight: 700;
  position: relative;
}

.frame-35732 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  /* padding: 0rem 3rem; */
}

.frame-35733 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  position: relative;
}

.small-chart {
  background: linear-gradient(to left, #e0f5ff, #e0f5ff),
    linear-gradient(to left, #e7ebf0, #e7ebf0);
  border-radius: 16px;
  padding: 24px 30px 24px 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex: 1;
  position: relative;
  box-shadow: 4px 4px 8px 0px rgba(0, 0, 0, 0.25),
    -4px -4px 8px 0px rgba(255, 255, 255, 1);
  cursor: pointer;
}

.frame-35703 {
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}

.cash {
  color: var(--dark-blue, #224096);
  text-align: left;
  font-family: "Figtree";
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  position: relative;
  width: 79.03px;
}

.label {
  color: var(--dark-blue, #224096);
  text-align: left;
  font-family: "Figtree";
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  opacity: 0.8999999761581421;
  position: relative;
}

.frame-35701 {
  flex-shrink: 0;
  /* width: 56px;
  height: 56px; */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.frame-35701 svg {
  width: 40px;
  height: 40px;
}

.wrapper-1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 30px;
  align-self: stretch;
  padding: 2rem 3rem;
}

.frame-35731 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* padding: 0rem 3rem; */
  gap: 20px;
}

.large-chart-per-month {
  flex-shrink: 0;
  width: 100%;
  height: 32vh;
  position: relative;
  overflow: hidden;
  align-self: stretch;
}

.frame-35734 {
  background: var(--dark-blue, #224096);
  border-radius: 16px;
  flex-shrink: 0;
  width: 30%;
  box-shadow: 0px 0px 30px 8px rgba(203, 229, 255, 1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
  padding: 25px 20px 10px 20px;
  align-self: stretch;
}

.accounts-payable-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
}

.accounts-payable {
  display: flex;
  width: 65%;
  flex-direction: column;
  align-items: flex-start;
}

.accounts-payable-value-wrapper {
  display: flex;
  align-items: center;
  gap: 16px;
}

.accounts-payable-value {
  color: white;
  font-family: "Figtree";
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.48px;
}

.accounts-payable-title {
  color: white;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  opacity: 0.8;
  align-self: stretch;
  text-align: left;
}

.days-due-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  width: 30%;
}

.days-button {
  display: flex;
  align-items: flex-start;
  border-radius: 8px;
  border: 2px solid #fff;
  overflow: hidden;
  align-self: stretch;
}

.days {
  display: flex;
  padding: 2px 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50%;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 6 00;
  line-height: 24px;
  letter-spacing: -0.32px;
  cursor: pointer;
}

.report-details-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  /* height: 50%;
  overflow-y: scroll;
  overflow-x: hidden;
  scrollbar-width: thin;
  -ms-overflow-style: none;
  scrollbar-color: rgba(255, 255, 255, 0.322) transparent; */
}

.report-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
}

.company-name {
  color: white;
  font-family: "Figtree";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 170%;
  letter-spacing: -0.28px;
  text-align: left;
  max-width: 75%;
}

.price {
  color: white;
  font-family: "Figtree";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 170%;
  letter-spacing: -0.28px;
}

.view-all {
  display: inline-flex;
  align-items: flex-start;
  gap: 7px;
  color: white;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  cursor: pointer;
}

.avg-data {
  display: inline-flex;
  height: 369px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  flex-shrink: 0;
}

.avg-card {
  display: flex;
  width: 357px;
  padding: 24px 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex: 1 0 0;
  border-radius: 16px;
  background: linear-gradient(to left, #e0f5ff, #e0f5ff),
    linear-gradient(to left, #e7ebf0, #e7ebf0);
  box-shadow: -4px -4px 8px 0px #fff, 4px 4px 8px 0px rgba(0, 0, 0, 0.25);
  gap: 10px;
}

.avg-value {
  color: var(--Dark-Blue, #224096);
  text-align: center;
  font-family: "Figtree";
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  letter-spacing: -0.48px;
}

.avg-lable {
  color: var(--Dark-Blue, #224096);
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  text-transform: capitalize;
  opacity: 0.9;
}

.map {
  display: flex;
  align-items: center;
  align-self: stretch;
  width: 100%;
  background: white;
  border-radius: 13px;
  overflow: hidden;
  box-shadow: rgba(174, 174, 192, 0.4) 10px 10px 30px 0px,
    rgb(255, 255, 255) -10px -10px 30px 0px;
}

.total-orders-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: space-between; */
  align-self: stretch;
  padding-left: 20px;
}

.total-orders {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.total-orders-title {
  color: var(--Dark-Blue, #224096);
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  text-transform: capitalize;
}

.total-orders-value {
  color: var(--Dark-Blue, #224096);
  font-family: "Figtree";
  font-size: 34px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: -0.68px;
  text-align: left;
}

.buttons-wrapper {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.buttons {
  text-align: center;
  font-family: "Figtree";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.32px;
  text-transform: capitalize;
  border-radius: 6px;
  padding: 5px 15px;
  cursor: pointer;
  box-shadow: 4px 5px 12px 0px rgba(174, 174, 192, 0.4);
}

.avg-count-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 25px;
}

@media only screen and (max-width: 767px) {
  .dashboard {
    margin-left: 0;
  }

  .frame-35701 svg {
    width: 30px;
    height: 30px;
  }

  .small-chart {
    align-self: stretch;
    padding: 18px;
  }

  .wrapper-1 {
    padding: 18% 4%;
    gap: 15px;
  }

  .frame-35733 {
    gap: 15px;
    flex-direction: column;
  }

  .buttons-wrapper {
    flex-direction: column;
  }

  .buttons {
    font-size: 14px;
    padding: 2px 10px;
  }

  .avg-count-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 0px;
  }

  .total-orders-wrapper {
    padding-left: 0;
    align-items: flex-start;
  }

  .total-orders-value {
    font-size: 16px;
  }

  .total-orders {
    gap: 0px;
  }

  .frame-35731 {
    flex-direction: column;
  }

  .avg-data {
    flex-direction: row;
    height: auto;
    align-self: stretch;
  }

  .avg-card {
    width: auto;
    align-self: stretch;
    justify-content: flex-start;
  }

  .avg-card svg {
    width: 35px;
    height: 35px;
  }

  .avg-value {
    font-size: 18px;
  }

  .avg-lable {
    font-size: 15px;
    line-height: 20px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1022px) {
  .wrapper-1 {
    padding: 11% 3% !important;
    gap: 15px;
  }

  .dashboard {
    margin-left: 0;
  }

  .frame-35731 {
    flex-direction: column;
  }

  .avg-data {
    flex-direction: row;
    height: auto;
    align-self: stretch;
  }

  .avg-card {
    width: auto;
    align-self: stretch;
  }

  .small-chart {
    padding: 15px;
  }
}

@media only screen and (min-width: 1156px) {
}
</style>
